import { Component } from '@angular/core';
import {Exception} from '../../models/error/Exception';
import {ExceptionService} from '../../services/error/exception.service';
import {BaseErrorDetailRecordComponent} from '../common/base-error-detail-record/base-error-detail-record.component';
import {ErrorDetailRuleComponent} from '../common/error-detail-rule/error-detail-rule.component';
import {TranslatePipe} from '@ngx-translate/core';
import {
    ErrorDetailTableRecordTemplateComponent
} from '../common/error-detail-table-record-template/error-detail-table-record-template.component';

@Component({
    selector: 'app-exception-detail-record',
    templateUrl: './exception-detail-record.component.html',
    styleUrls: ['./exception-detail-record.component.css'],
    standalone: true,
    imports: [
        ErrorDetailRuleComponent,
        ErrorDetailTableRecordTemplateComponent,
        TranslatePipe,
    ]
})
export class ExceptionDetailRecordComponent extends BaseErrorDetailRecordComponent<Exception> {
    constructor(private exceptionService: ExceptionService) {
        super(exceptionService);
    }
}
